const IMAGES = [
  'bear.png',
  'bee.png',
  'bird.png',
  'bunny.png',
  'cloud.png',
  'floral_twig.png',
  'flower.png',
  'flower_02.png',
  'rain_cloud.png',
  'rain_cloud_02.png',
  'rainbow.png',
  'sun.png',
  'swirl.png',
  'trees.png',
  'waves.png',
  'zig_zag.png',
]
const COLORS = ['#bdb6e0', '#ffb3ab', '#99D6EA', '#5CA3B3', '#A1D884', '#74AA50', '#5CA3B3', '#FFC56E', '#ED9B33', '#CBA3D8', '#A05EB5']

// Module-scoped variable so that we'll have a good distribution of avatars,
// even if two sets of avatars are used on the same page.
// Always start with a different index such that each load into the app will show different avatars.
let imageIndex = Math.floor(Math.random() * COLORS.length)
let colorIndex = Math.floor(Math.random() * IMAGES.length)

export const getNextAvatar = () => {
  const result = {
    image: {
      src: `/hb/${IMAGES[imageIndex % IMAGES.length]}`,
      alt: 'Contributor',
    },
    color: COLORS[colorIndex % COLORS.length],
  }

  imageIndex++
  colorIndex++

  return result
}
